import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex items-center space-x-10" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "sr-only" }
const _hoisted_4 = {
  width: "16",
  height: "16",
  class: "group-hover:shake-left h-4 w-4",
  "aria-hidden": "true",
  focusable: "false"
}
const _hoisted_5 = { class: "flex space-x-1 text-sm" }
const _hoisted_6 = { class: "sr-only" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "sr-only" }
const _hoisted_9 = { class: "p-2 text-base" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "sr-only" }
const _hoisted_12 = { class: "sr-only" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "sr-only" }
const _hoisted_15 = { class: "block rotate-180 transform" }
const _hoisted_16 = {
  width: "16",
  height: "16",
  class: "group-hover:shake-right h-4 w-4",
  "aria-hidden": "true",
  focusable: "false"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "border group inline-flex items-center justify-center rounded-full p-4",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prev && _ctx.prev(...args))),
      disabled: _ctx.from === 1
    }, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.t('previous')), 1),
      (_openBlock(), _createElementBlock("svg", _hoisted_4, [
        _createElementVNode("use", _normalizeProps(_guardReactiveProps({ 'xlink:href': '#arrow-left' })), null, 16)
      ]))
    ], 8, _hoisted_2),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.page !== 1 && !_ctx.before.includes(1))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "p-2 opacity-20 hover:opacity-100",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goto(1)))
          }, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.t('page')), 1),
            _cache[4] || (_cache[4] = _createTextVNode(" 1 "))
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.before, (page) => {
        return (_openBlock(), _createElementBlock("button", {
          key: page,
          class: "p-2 opacity-20 hover:opacity-100",
          onClick: ($event: any) => (_ctx.goto(page))
        }, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.t('page')), 1),
          _createTextVNode(" " + _toDisplayString(page), 1)
        ], 8, _hoisted_7))
      }), 128)),
      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.page), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.after, (page) => {
        return (_openBlock(), _createElementBlock("button", {
          key: page,
          class: "p-2 opacity-20 hover:opacity-100",
          onClick: ($event: any) => (_ctx.goto(page))
        }, [
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.t('page')), 1),
          _createTextVNode(" " + _toDisplayString(page), 1)
        ], 8, _hoisted_10))
      }), 128)),
      (_ctx.page !== _ctx.maxPage && !_ctx.after.includes(_ctx.maxPage))
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "p-2 opacity-20 hover:opacity-100",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goto(_ctx.maxPage)))
          }, [
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.t('page')), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.maxPage), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("button", {
      class: "border group inline-flex items-center justify-center rounded-full p-4",
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args))),
      disabled: _ctx.to === _ctx.totalCount
    }, [
      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.t('next')), 1),
      _createElementVNode("span", _hoisted_15, [
        (_openBlock(), _createElementBlock("svg", _hoisted_16, [
          _createElementVNode("use", _normalizeProps(_guardReactiveProps({ 'xlink:href': '#arrow-left' })), null, 16)
        ]))
      ])
    ], 8, _hoisted_13)
  ]))
}